import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DATA_MODE_INVALID_FOR_NEGATIVE_VALUES, DATA_MODE_INVERSE_LABELS, DataMode, DisplaySettingsChange, LayerDescriptor, LayerSelection, LayerVariant, OverlaySelection } from '../data';
import { LayersService } from '../layers.service';
import * as R from 'ramda';

@Component({
  selector: 'app-map-layer-selection',
  templateUrl: './map-layer-selection.component.html',
  styleUrls: ['./map-layer-selection.component.scss']
})
export class MapLayerSelectionComponent implements OnInit, OnChanges {
  @Output() selectionChanged = new EventEmitter<LayerSelection>();
  @Output() displaySettingsChange = new EventEmitter<DisplaySettingsChange>();
  @Input() layerSelection: OverlaySelection;
  @Input() choropleth: boolean;
  @Input() choroplethAvailable = true;

  layer: LayerDescriptor;
  selectedVariant:LayerVariant;
  anomaly:string;

  layers: LayerDescriptor[];
  layerVariants:LayerVariant[] = [];

  dataMode:DataMode
  allDataModes:{
    mode:DataMode,
    label:string
  }[] = Object.keys(DATA_MODE_INVERSE_LABELS).map(lbl=>({mode:DATA_MODE_INVERSE_LABELS[lbl],label:lbl}));

  dataModes:{
    mode:DataMode,
    label:string
  }[] = [];

  constructor(private layersService:LayersService) {
    this.dataModes = this.allDataModes.slice();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.layerSelection){
      this.layer = this.layerSelection?.layer;
      this.selectedVariant = this.layerSelection?.variant;
      this.dataMode = this.layerSelection?.dataMode;
      this.setLayer(this.layer);
    }
  }

  ngOnInit(): void {
    this.layersService.layerConfig$.subscribe(layers=>{
      this.layers = layers;
      this.setLayer(this.layer||this.layers[0]);
    });
  }

  setLayer(layer: LayerDescriptor) {
    this.layerVariants = layer?.variants||[];
    if(this.layer===layer){
      return;
    }

    this.layer = layer;
    if(this.selectedVariant){
      this.selectedVariant = this.layerVariants.find(v=>v.variantLabel===this.selectedVariant.variantLabel);
    } else {
      this.selectedVariant = this.layerVariants[0];
    }

    this.ensureValidDataMode();

    this.emit();
  }

  layerChanged() {
    this.layerVariants = this.layer?.variants||[];
    this.selectedVariant = this.layerVariants[0];
    this.ensureValidDataMode();

    this.emit();
  }

  ensureValidDataMode(): void {
    this.dataModes = this.layerCanBeNegative() ? this.allDataModes.filter(dm=>!DATA_MODE_INVALID_FOR_NEGATIVE_VALUES[dm.mode]) : this.allDataModes.slice();
    this.dataMode = this.dataMode || DataMode.NORMAL;
    if(!this.dataModes.find(dm=>dm.mode===this.dataMode)){
      this.dataMode = DataMode.NORMAL;
    }
  }

  layerCanBeNegative():boolean{
    const refStyles = this.selectedVariant?.gridStyles || this.selectedVariant?.zonalStyles || this.selectedVariant?.pointStyles || 
                      this.layer?.gridStyles || this.layer?.zonalStyles || this.layer?.pointStyles;
    const classes = refStyles?.classes || [];
    return R.any(c=>c<0,classes);
 }

  variantChanged():void{
    this.ensureValidDataMode();
    this.emit();
  }

  dataModeChanged(): void {
    this.emit();
  }

  emit() {
    this.selectionChanged.emit({
      layer:this.layer,
      variant:this.selectedVariant,
      dataMode:this.dataMode
    });
  }

  choroplethToggled(): void {
    this.displaySettingsChange.emit({
      setting:'choropleth',
      value:this.choropleth
    });
  }
}

